module.exports = __webpack_public_path__ + "985933c5b8158c435951407411d2a181.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatext/KOMTXT.eot
// module id = 92
// module chunks = 0